import React from 'react';
import PropTypes from 'prop-types';
import {
    Box,
    Switch,
    Tooltip,
} from '@material-ui/core';

import { Typography } from '../../../components/Wrappers/Wrappers.jsx';
import Dialog from '../../../commons/dialog/Dialog';
import { useStyles } from './listingSection.styles';

function DiscoverableToggleCard (props) {
    const {
        isPublic,
        confirmOpen,
        tooltipTitle,
        dialogTitle,
        dialogText,
        onToggle,
        onConfirm,
        onCancel,
    } = props;

    const classes = useStyles();

    return (
        <>
            <Box className={classes.toggleCard}>
                <Box flex={1} minWidth={0}>
                    <Typography variant={'body1'} className={classes.toggleTitle}>
                        Be Discoverable in ECAL World
                    </Typography>
                    <Typography variant={'body2'} className={classes.toggleDescription}>
                        When this is on, your brand tile is published to ECAL World and consumers can
                        find and sync your schedules. Turn it off at any time to remove your listing.
                    </Typography>
                </Box>

                <Tooltip title={tooltipTitle}>
                    <Switch
                        checked={isPublic}
                        onClick={onToggle}
                        color={'primary'}
                        inputProps={{ 'aria-label': 'Be Discoverable in ECAL World' }}
                    />
                </Tooltip>
            </Box>

            <Dialog
                openDialog={confirmOpen}
                buttonSecondary={'Cancel'}
                handleAgree={onConfirm}
                closeModal={onCancel}
                title={dialogTitle}
                dialogContextText={dialogText}
            />
        </>
    );
}

DiscoverableToggleCard.propTypes = {
    isPublic: PropTypes.bool.isRequired,
    confirmOpen: PropTypes.bool.isRequired,
    tooltipTitle: PropTypes.string.isRequired,
    dialogTitle: PropTypes.string.isRequired,
    dialogText: PropTypes.string.isRequired,
    onToggle: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default DiscoverableToggleCard;
